var styles = {"fontElementMap":"bzEEy","orderedlist":"zOuvR","bulletedlist":"xErDo","listItem":"_04hd2"};

export { styles as s };
//# sourceMappingURL=lists-59e3ab51.js.map
